import GUI from "../GUI";
import TreeNode, { TTreeNode, TTreeNodeProps } from "./TreeNode";

export type TTreeViewProps<T extends TTreeNode<T>> = Omit<TTreeNodeProps<T>, "level">

export default function TreeView<T extends TTreeNode<T>>(props:TTreeViewProps<T>) {
    return <div className={GUI.joinClass("treenode", props.className)}>
        <TreeNode {...props} level={0}/>
    </div>

}